// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3wS5o","validationTips":"StatementDescriptor_validationTips__10QIx"};